import { takeLatest } from 'redux-saga/effects';
import {
  getEmployeeListSuccess, getEmployeeListFail,
  getEmployeeDetailsSuccess, getEmployeeDetailsFail
} from './employeeState';
import createCrudService from '../../services/crudservice';
import { doCrudCall } from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/admin/accounts');
const redirectData = {route:'/console/accounts', mode: 'list', recordId:0 };
const modelName = 'Employees';
const modelId = 'id';

function* getEmployeeList(data) {
	const { accountId, ...params } = data.payload;
	const childEndpoint = `${accountId}/employees`;
	console.log(childEndpoint);
	yield doCrudCall(
		() => crudService.getList(params, childEndpoint), 
		getEmployeeListSuccess, 
		getEmployeeListFail);
}

function* getEmployeeDetails(data) {
	const { accountId, recordId } = data.payload;
	const childEndpoint = `${accountId}/employees`;
	yield doCrudCall(
		() => crudService.getDetails(recordId, childEndpoint), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail);		
}

function* doEmployeeCreate(data){
	const childEndpoint = `${data.payload.account_id}/employees`;
	yield doCrudCall(
		() => crudService.doCreate(data.payload, childEndpoint), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail,
		`${modelName} record has been created.`,
		{...redirectData, route:`/console/accounts/${data.payload.account_id}/view`});
}

function* doEmployeeUpdate(data){
	const childEndpoint = `${data.payload.account_id}/employees`;
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload, childEndpoint), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail,
		`${modelName} record has been updated.`,
		{...redirectData, route:`/console/accounts/${data.payload.account_id}/employees/${data.payload[modelId]}/view`});	
}

function* doEmployeeDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getEmployeeDetailsSuccess, 
		getEmployeeDetailsFail,
		`${modelName} record has been deleted.`,
		{...redirectData, route:`/console/accounts/${data.payload.account_id}/view`});	
}

function* employeeSaga() {
  yield takeLatest('employee/getEmployeeList', getEmployeeList);
  yield takeLatest('employee/getEmployeeDetails', getEmployeeDetails);
  yield takeLatest('employee/doEmployeeCreate', doEmployeeCreate);
  yield takeLatest('employee/doEmployeeUpdate', doEmployeeUpdate);
  yield takeLatest('employee/doEmployeeDelete', doEmployeeDelete);  
}

export default employeeSaga;
